/**
 * 人员卡片分享
 */
import React, { useCallback, useMemo, useState } from "react";
import { MessageSendType } from "@/types/chat/enum";
import "./index.less";
import ShareUserCard from "@/components/chat/message/share/UserCard";
import ChatState from "@/types/chat/State";
import { getTextMessageRemark } from "@/components/chat/utils/commonMessageModal";
import { connect } from "dva";
import IconFont from "@/components/icon";
import config, { ConfigEnum, ChatConfig } from "@/config/config";
import { mapUserDataToUserCard } from "@/components/UserCard/common";
import { NetState } from "@/models/netStatus";
import { useHistory, useLocation } from "react-router-dom";
import { getUserEbookDetail } from "@/api/ebook";
import { AVSDK } from "@/baseComponents/Meeting/common";
import { FocusSDK } from "@/utils";
import { useTranslation } from "react-i18next";
import ReferenceHeader from "../ReferenceHeader";
import AiFootnote from "@/baseComponents/Chat/AIFootnote";

function mapStateToProps({ chat, netStatus }: { chat: ChatState; netStatus: NetState }) {
  const { currentEmployee, selectedSession, connectState } = chat;
  return {
    userInfo: currentEmployee,
    currentEmployee,
    selectedSession,
    connectState,
    newPublicResult: netStatus.newPublicResult
  };
}

function mapDispatchToProps(dispatch: any) {
  return {};
}

function ShareUserCardList(props: any) {
  const { t } = useTranslation("chat");
  const {
    currentEmployee,
    selectedSession,
    message,
    sessionType,
    sendType,
    onReady,
    newPublicResult
  } = props;
  const [showMore, setShowMore] = useState<boolean>(false);
  // 扩展数据
  const extData = useMemo(() => {
    if (!message?.ext) {
      return {};
    }
    try {
      return typeof message?.ext === "string" ? JSON.parse(message?.ext) : message?.ext;
    } catch (e) {
      return {};
    }
  }, [message?.ext]);

  const showFooter = useMemo(() => {
    return (message?.data?.length || 0) > 3 && !showMore;
  }, [message?.data?.length, showMore]);

  // 是否可加搜索好友
  const canSearchUser = useMemo(() => {
    return config[ConfigEnum.EXTERNAL_CONTACTS_ADD_CONTACTS] && extData?.keyword;
  }, [extData.keyword]);

  // 加入会议
  const handleJoinMeeting = useCallback(
    async (e: any, data: any) => {
      if (!data) {
        return;
      }
      e?.stopPropagation();
      try {
        const user: any = await getUserEbookDetail({
          userId: data?.userId || data?.pin,
          teamId: data?.teamId,
          appId: data?.appId || data?.app,
          isMulti: false
        });
        if (user) {
          const avatar = user?.fields?.find((i: any) => i.key === "avatar");
          const name = user?.fields?.find((i: any) => i.key === "name");
          const from = {
            app: currentEmployee.app,
            teamId: currentEmployee.teamId,
            pin: currentEmployee.userId,
            avatar: currentEmployee.avatar,
            name: currentEmployee.name
          };
          const to = {
            pin: user.userId,
            teamId: user.teamId,
            app: user.appId,
            avatar: avatar?.val || "",
            name: name?.val || ""
          };
          if (config[ConfigEnum.CHAT_SESSION_CREATE_JD_VIDEO_ENABLE]) {
            FocusSDK.sendToMain("ai:mt:single:meeting:create", {
              from,
              to,
              avsdk: AVSDK.JBRTC,
              type: ""
            });
          } else {
            FocusSDK.sendToMain("ai:mt:group:meeting:create", {
              to: user,
              from: currentEmployee,
              netState: newPublicResult
            });
          }
        }
      } catch (e) {}
    },
    [currentEmployee, newPublicResult]
  );

  // 打开会话
  const handleChat = useCallback((e: any, data: any) => {
    e?.stopPropagation();
    const cardData = mapUserDataToUserCard(data);
    const path = `/messages/s/${cardData.userId}?app=${cardData?.appId}&tid=${cardData.teamId}`;
    FocusSDK.launchNewSession(path);
  }, []);

  // 操作区
  const getCustomFooterNode = (data: any) => {
    return (
      <div className="card-footer">
        {config[ChatConfig.CHAT_SESSION_CREATE_MEETING_ENABLE] && <div className="item" onClick={(e) => handleJoinMeeting(e, data)}>
          <IconFont className="icon" type="iconapp_btn_joymerting_video" />
          视频通话
        </div>}
        <div className="item" onClick={(e) => handleChat(e, data)}>
          <IconFont className="icon" type="iconic_chat" />
          发消息
        </div>
      </div>
    );
  };

  const aiTitle = useMemo(() => {
    return extData?.ai_type || "";
  }, [extData.ai_type]);

  return (
    <div className="content">
      <div className={`card-container ${sendType === MessageSendType.OTHER ? "other" : ""}`}>
        {aiTitle ? (
          <div className="share-card-title-wrap">
            <span>使用</span>
            <div className="title-name">{`「${aiTitle}」`}</div>
          </div>
        ) : null}
        <ReferenceHeader refs={message?.refs} />
        <AiFootnote message={message}>
          <div
            className={`top-box ${selectedSession.isSecret ? "top-box_isSecret" : ""}`}
            dangerouslySetInnerHTML={{
              __html: getTextMessageRemark(selectedSession, message, currentEmployee, "", -1).trim()
            }}
          />
        </AiFootnote>
        {message.data?.length ? (
          <div className={`card-wrap${showMore ? " showMore" : ""}`}>
            {message.data?.map((d: any, idx: number) => {
              return (
                <ShareUserCard
                  sendType={sendType}
                  onReady={onReady}
                  message={{ ...message, data: [d] }}
                  sessionType={sessionType}
                  key={`${message.id}_${idx}`}
                  clsName={`small-card ${message.data?.length === 1 ? "single" : ""}`}
                  showFooter={false}
                  customFooter={
                    message.data?.length === 1 ? getCustomFooterNode(d?.sharecard) : null
                  }
                />
              );
            })}
          </div>
        ) : null}
        {showFooter ? (
          <div className="footer" onClick={() => setShowMore(true)}>
            查看更多
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ShareUserCardList);
